import React, {useEffect, useRef} from 'react';
import FormInput from "../../formComponents/FormInput";
import FormBlock from "../../formComponents/FormBlock";
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";
import FormLinkedItemSimpleSelect from "../../formComponents/FormLinkedItemSimpleSelect";
import {allAuthorTagKinds} from "../../data/Enums";

const TagsItemForm = ({initData, controlRef}) => {

    const controlRefName = useRef(null);
    const controlRefAuthorTagKind = useRef(null);

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                validate: validate,
                getData: getData,
            };
        }
    });

    function validate() {
        let isValid = true;

        if (!controlRefName.current.validateNotEmpty("Нужно указать название!"))
            isValid = false;

        if (!controlRefName.current.validateLength(255))
            isValid = false;

        if (!controlRefAuthorTagKind.current.validateIsSelected("Нужно выбрать категорию!"))
            isValid = false;

        return isValid;
    }

    function getData() {
        return {
            name: controlRefName.current.getText(),
            author_tag_kind: controlRefAuthorTagKind.current.getSelectedId(),
        }
    }

    return (
        <BaseSimpleItemEditorForm>
            <FormBlock title="Основные">
                <FormInput
                    controlRef={controlRefName}
                    label="Название"
                    widthLimit={350}
                    initValue={initData?.name ?? ""}
                />
                <FormLinkedItemSimpleSelect
                    controlRef={controlRefAuthorTagKind}
                    label="Категория (для деятелей)"
                    widthLimit={250}
                    initSelectedId={initData?.author_tag_kind}
                    options={allAuthorTagKinds}
                />
            </FormBlock>
        </BaseSimpleItemEditorForm>
    );
};

export default TagsItemForm;